
    export enum TabBrowseDirection
    {
        FORWARD = 'forward',
        BACKWARD = 'backward'
    }